import React from 'react';

function Error() {
  return (
    <div>
      <h1>This is an error</h1>
    </div>
  );
}

export default Error;
